import { cn } from '@/lib/utils';

// Studio Blueprint 05-A (2026-10-16): the spec plate, a film-slate style list of facts
// under an output. Rows come from the job or order record only: a row whose
// value is missing is dropped, never guessed ("never show a number you can't
// query live"). Labels and values arrive already translated.
export interface SpecRow {
  label: string;
  value: string | null | undefined;
}

export function SpecPlate({ rows, title, className }: { rows: readonly SpecRow[]; title?: string; className?: string }) {
  const shown = rows.filter((row): row is { label: string; value: string } => typeof row.value === 'string' && row.value.trim() !== '');
  if (shown.length === 0) return null;
  return (
    <div
      data-testid="spec-plate"
      className={cn('mx-auto max-w-xl rounded-2xl border border-foreground/10 bg-card/70 px-4 py-3 font-mono text-xs', className)}
    >
      {title && <p className="mb-2 font-semibold uppercase tracking-[0.14em] text-muted-foreground">{title}</p>}
      <dl className="grid grid-cols-2 gap-x-4 gap-y-1.5 sm:grid-cols-3">
        {shown.map((row) => (
          <div key={row.label} className="min-w-0">
            <dt className="uppercase tracking-[0.1em] text-muted-foreground">{row.label}</dt>
            <dd className="truncate font-semibold text-foreground">{row.value}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}
